<!--
 * @Author: 张亚欣 18911148524@163.com
 * @Date: 2021-12-03 14:36:43
 * @LastEditors: 张亚欣 18911148524@163.com
 * @LastEditTime: 2022-06-24 13:51:53
 * @FilePath: \lightning-web\src\views\colleagueCircle\components\dynamic-applyFor\AgreeJoinIn.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
  同意加入弹框
-->
<template>
  <el-dialog
    :visible.sync="agreeJoinIn"
    :title="$t('vue_label_chatter_agree_join')"
    :before-close="handleClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div>
        <!-- <p>确定同意"{{ name }}"加入小组吗?</p> -->
        <p>{{ $t("vue_label_chatter_applycertification", { name: name }) }}</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="agreeJoinInCancel">{{
        $t("button_partner_cancel")
      }}</el-button>
      <el-button type="primary" @click="agreeJoinInConfirm">{{
        $t("label.ems.confirm")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    agreeJoinInTo: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      agreeJoinIn: false,
    };
  },
  watch: {
    agreeJoinInTo: {
      handler: function (newVal) {
        this.agreeJoinIn = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("agreeJoinInCancel");
    },
    agreeJoinInCancel() {
      this.$emit("agreeJoinInCancel");
    },
    agreeJoinInConfirm() {
      this.$emit("agreeJoinInConfirm");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 552px;
  // height: 390px;
}
.dialog-body {
  div {
    p {
      font-size: 16px;
      color: #686868;
    }
  }
}
</style>
